import { render, staticRenderFns } from "./dashboard-prm.vue?vue&type=template&id=06a26d12&scoped=true"
import script from "./dashboard-prm.vue?vue&type=script&lang=js"
export * from "./dashboard-prm.vue?vue&type=script&lang=js"
import style0 from "./dashboard-prm.vue?vue&type=style&index=0&id=06a26d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a26d12",
  null
  
)

export default component.exports